<template>
    <div class="video-container">
        <!-- 视频元素，设置为全屏并自动循环播放 -->
        <video class="fullscreen-video" :src="videoSource" autoplay loop muted playsinline
            @loadedmetadata="onVideoLoaded">
            您的浏览器不支持HTML5视频播放
        </video>

        <!-- 加载状态指示器 -->
        <div v-if="isLoading" class="loading-indicator">
            <div class="spinner"></div>
            <p class="loading-text">加载中...</p>
        </div>
        <div class="mask"></div>
        <div class="content-box">
            <div class="title">华艺元界 X 线上展馆</div>
            <div class="desc">
                构建虚拟与现实交融的
            </div>
            <div class="desc-2">
                未来展示新生态
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'VideoFullscreen',
    data () {
        return {
            // 视频源地址，可以替换为实际的视频URL
            videoSource: require('@/assets/room.mp4'),

            isLoading: true
        }
    },
    methods: {
        // 视频元数据加载完成后隐藏加载指示器
        onVideoLoaded () {
            this.isLoading = false
        },
        // 处理窗口大小变化
        handleResize () {
            const video = document.querySelector('.fullscreen-video')
            if (video) {
                // 确保视频填充整个屏幕
                video.style.width = `${window.innerWidth}px`
                video.style.height = `${window.innerHeight}px`
            }
        }
    },
    mounted () {
        // 监听窗口大小变化，确保视频始终充满屏幕
        window.addEventListener('resize', this.handleResize)

        // 初始调整视频尺寸
        this.handleResize()
    },
    beforeDestroy () {
        // 移除事件监听
        window.removeEventListener('resize', this.handleResize)
    }
}
</script>

<style  lang="less" scoped>

.video-container {
    position: relative;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background-color: #fff;
    .mask{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 1;

    }

    .content-box{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #fff;
        z-index: 2;
        .title{
            font-size: 28px;
            font-weight: 700;
            border: 1px solid #fff;
            padding: 10px 20px;
            border-radius: 28px;
            margin-bottom: 10px;
            box-sizing: border-box;
        }
        .desc{
            font-size: 24px;
            font-weight: 700;

        }
        .desc-2{
            font-size: 24px;
            font-weight: 700;
        }

    }

}

.fullscreen-video {
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
    /* 保持视频比例并覆盖整个容器 */
}

/* 加载指示器样式 */
.loading-indicator {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: white;
    z-index: 10;
}

.spinner {
    width: 40px;
    height: 40px;
    margin: 0 auto;
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top: 4px solid white;
    animation: spin 1s linear infinite;
}

.loading-text {
    margin-top: 10px;
    font-size: 16px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

/* 针对移动设备的优化 */
@media (max-width: 768px) {
    .fullscreen-video {
        touch-action: none;
        /* 防止触摸时出现默认行为 */
    }
}
</style>
